export default {
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  }
}